<template>
  <div class="search-container">
    <!-- <qrcode :top="254"></qrcode> -->
    <div v-if="listIsEmpty">
      <div v-if="goodsList.length > 0">
        <goods-type
          @changeLimits="changeListLimits(arguments)"
          @changeType="handleChangeType(arguments)"
          :typeList="typeList"
        >
        </goods-type>
        <goodsheader
          @changeType="getType"
          :total="total"
          :pageNumber="pageNumber"
          :pageSize="pageSize"
          @changenum="changePage"
          @changeCheckbox="isStock"
          @changeSort="isSort"
        ></goodsheader>
        <div class="con">
          <goodslistceil2
            v-if="type == 1"
            :goodsList="goodsList"
          ></goodslistceil2>
          <goodslistceil v-else :goodsList="goodsList"></goodslistceil>
          <el-pagination
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            @current-change="e => (pageNumber = e)"
            :total="total"
            :current-page="pageNumber"
            v-if="!$route.query.isReplenish"
          >
          </el-pagination>
        </div>
      </div>
      <div v-else class="con empty">
        <div class="empty-img">
          <img :src="require('@/assets/images/sousuo.png')" alt="" />
        </div>
        <div class="empty-con">
          <p class="p1">{{ message }}</p>
          <p class="p2">建议您：</p>
          <p class="p3">1.查看输入的文字是否有错误</p>
          <p class="p4">
            2.或是 <span @click="showNeed = true">需求登记</span>
          </p>
        </div>
      </div>
    </div>
    <goodsneed :show="showNeed" @close="getclose"></goodsneed>
    <smActivity ref="smAct"></smActivity>
  </div>
</template>

<script>
import goodsType from "./components/goods-type.vue";
import goodsheader from "./components/goods-header";
import goodslistceil from "../../../components/goods-list-ceil";
import goodslistceil2 from "../../../components/goods-list-ceil-2";
import goodsneed from "./components/goods-need";
import qrcode from "../../../components/plugins/qrcode";
import { mapState } from "vuex";
export default {
  components: {
    goodsType,
    goodslistceil2,
    goodsheader,
    goodslistceil,
    goodsneed,
    qrcode
  },
  data() {
    return {
      listIsEmpty: false,
      type: 1,
      goodsList: [],
      typeList: [],
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      maxPrice: "", //	最高价
      minPrice: "", //最低价
      hasStock: "", //是否有库存:yes,no
      orderType: "", //排序
      jixing: "",
      brandId: "",
      tagId: "",
      showNeed: false,
      message: ""
    };
  },
  created() {
    this.getGoodsList(1);
  },
  mounted() {
    let nowData = new Date().toLocaleDateString();
    let active = JSON.parse(localStorage.getItem("smActivity"));
    let time = nowData == localStorage.getItem("startTime");
    if (active && time) {
      this.showSm = true;
      return;
    } else {
      this.$api.POST_SECRETACTIVITY().then(res => {
        if (res.data.opened) {
          let startDate = new Date().toLocaleDateString();
          // console.log(myDate.getTime());
          localStorage.setItem("smActivity", true);
          localStorage.setItem("activityId", res.data.special.id);
          localStorage.setItem("startTime", startDate);

          this.$refs.smAct.showdhtx = true;
        } else {
          localStorage.setItem("smActivity", false);
        }
      });
    }
  },
  computed: {
    //...mapState(["searchkeyword"])
  },

  methods: {
    getclose(data) {
      this.showNeed = data;
    },
    //接收列表  表格切换
    getType(data) {
      this.type = data;
    },
    //接收页码改变
    changePage(data) {
      this.pageNumber += data;
      if (this.pageNumber <= 0) {
        this.pageNumber = 1;
      } else if (this.pageNumber >= Math.ceil(this.total / this.pageSize)) {
        this.pageNumber = Math.ceil(this.total / this.pageSize);
      }
    },
    //接受价格范围变动
    changeListLimits(msg) {
      this.minPrice = msg[0];
      this.maxPrice = msg[1];
      this.getGoodsList(1);
    },

    handleChangeType(msg) {
      this.jixing = msg[0];
      this.tagId = msg[1];
      this.brandId = msg[2];
      //console.log(this.brandId)
      this.getGoodsList(1);
    },
    //是否有货
    isStock(data) {
      this.hasStock = data ? "yes" : "";
      this.getGoodsList(1);
    },
    isSort(data) {
      console.log(data);
      this.orderType = data;
      this.getGoodsList(1);
    },
    getGoodsList(e) {
      console.log(4444, e);
      var node = this.$route.query.node;
      var categoryId = this.$route.query.id;
      var categoryIds = this.$route.query.categoryIds;
      var ids = this.$route.query.ids;
      var brandIds = this.$route.query.brandIds;
      var labels = this.$route.query.labels;
      var tagId = this.$route.query.tagId;
      var keyword = this.$route.query.keyword;
      var brandId = this.$route.query.brandId;
      var isControl = this.$route.query.isControl;
      this.pageNumber = e;
      this.$api
        .GET_GOODSLIST({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          keyword: keyword,
          minPrice: this.minPrice,
          maxPrice: this.maxPrice,
          hasStock: this.hasStock,
          orderProperties: this.orderType.orderProperties,
          orderType: this.orderType.orderType,
          brandId: brandId || this.brandId,
          tagId: this.tagId || tagId,
          jixing: this.jixing,
          labels: labels || this.labels,
          categoryIds: categoryIds || this.categoryIds,
          ids: ids || this.categoryIds,
          brandIds: brandIds || this.brandIds,
          isControl: isControl || false,
          [node || "categoryId"]: categoryId || this.categoryId
        })
        .then(res => {
          if (res.status) {
            this.goodsList = res.data.pageable.data;
            this.total = res.data.pageable.total;
            this.typeList = res.data;
            this.listIsEmpty = true;
            if (this.goodsList.length == 0) {
              this.message =
                "抱歉，没有找到" +
                (keyword ? "“" + keyword + "”" : "") +
                "相关的商品，要不您换个关键词帮您找找看";
            }
          } else {
            this.listIsEmpty = true;
            this.message = "搜索内容可能涉及不符合相关法律法规和政策的内容";
          }
        });
    },
    initType() {
      this.minPrice = "";
      this.maxPrice = "";
      this.orderType = "";
      this.brandId = "";
      this.tagId = "";
      this.jixing = "";
    }
  },

  watch: {
    "$route.query"(t, f) {
      this.initType();
    },
    // searchkeyword(t,f){
    //   this.minPrice = '',
    //   this.maxPrice = '',
    //   this.orderType = '',
    //   this.brandId = '',
    //   this.tagId = '',
    //   this.jixing = '',

    //   this.getGoodsList(1);
    // },
    pageNumber(t, f) {
      this.getGoodsList(t);
    },
    $route: function(t, f) {
      this.getGoodsList(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-container {
  min-height: calc(100vh - 366px);
  background-color: #fafafa;
}
.pagination {
  text-align: center;
  padding: 40px 0;
  color: #fa4b4b;
}
.empty {
  height: 260px;
  display: flex;
  background-color: #fcfcfc;
  .empty-img {
    margin: 56px 36px 0 192px;
  }
  .empty-con {
    margin-top: 70px;
    .p1 {
      font-size: 16px;
      color: #505050;
      margin-bottom: 24px;
    }
    .p2,
    .p3,
    .p4 {
      font-size: 14px;
      color: #808080;
    }
    .p2,
    .p3 {
      margin-bottom: 18px;
    }
    .p4 {
      span {
        display: inline-block;
        border-radius: 4px;
        width: 80px;
        height: 30px;
        background-color: #fa4b4b;
        cursor: pointer;
        @include font(14px, #ffffff, center, 400, 30px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/search/index.vue